/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { RouteLocationRaw } from '#vue-router'

export function useAppSearch() {
  const query = useState('app:search:q', () => shallowRef({ q: '' }))
  const loading = useState('app:search:load', () => shallowRef({ l: false }))
  const { myLink, linkProduct } = useLinks()
  const isB2B = useIsB2B()

  type ToSearch = (args: { query?: string; nonce?: string; slug?: string; category?: string }) => RouteLocationRaw
  type ToProduct = (p: { slug: string }) => RouteLocationRaw | undefined
  type SearchRotues = { toSearch: ToSearch; toProduct: ToProduct }

  // const sellerRoutes = (seller: string): SearchRotues => ({
  //   toSearch: (i) => myLink('@seller-s', { seller }, { nonce: i.nonce, q: i.query, d: i.category }),
  //   toProduct: (slug) => myLink('@seller-p-slug', { slug, seller }),
  // })
  const mainRoutes: SearchRotues = {
    toSearch: (i) => myLink(isB2B.value ? 'b2b-search' : 'search', {}, { nonce: i.nonce, q: i.query, d: i.category }),
    toProduct: (p) => linkProduct(p),
  }

  // const { handle, sellerId } = useSeller('browser')
  const searchUi = computed((): SearchRotues => {
    // const h = handle.value
    // return h ? sellerRoutes(h) : mainRoutes
    return mainRoutes
  })

  // , sellerId
  return {
    isB2B,
    querySet(q: string) {
      query.value = { q }
    },
    loadingSet(l: boolean) {
      loading.value = { l }
    },
    query: toRef(() => query.value.q),
    loading: toRef(() => loading.value.l),
    searchUi,
  }
}
